import React, { useCallback } from 'react';

import { useAuthenticationContext } from '~/App/contexts/Authentication';
import useLogin from '~/App/shared/hooks/use-login';
import useLoginModal from '~/App/shared/hooks/use-login-modal';
import { ensureLegalAge } from '~/App/helpers/ssn-helper';
import { Alert } from '~/App/shared/components/Alert';

import {
  P,
  ButtonWrapper,
  OutlineButton,
  LinkButton,
  ContactLink
} from './styled';
import { Props } from './types';

export function LegalAgeVerification(props: Props) {
  const { children } = props;
  const { user, isAuthenticated } = useAuthenticationContext();
  const login = useLogin();
  const loginModal = useLoginModal();
  const hasLegalAge = ensureLegalAge(user?.ssn ?? '');

  const handleClick = useCallback(
    async (sameDevice) => {
      login.handlers.handleLogin({
        qrInit: !sameDevice,
        sameDevice: sameDevice
      });
      loginModal.handlers.toggleQrMode(!sameDevice);
    },
    [login.handlers, loginModal.handlers]
  );

  if (!isAuthenticated) {
    return (
      <>
        <P>
          Åldersgräns för lottköp är 18 år. Logga in med BankID för att
          verifiera din ålder och hämta dina uppgifter.
        </P>
        <ButtonWrapper>
          <OutlineButton type="button" onClick={() => handleClick(true)}>
            BankID på denna enhet
          </OutlineButton>
          <LinkButton type="button" onClick={() => handleClick(false)}>
            BankID på annan enhet
          </LinkButton>
        </ButtonWrapper>
      </>
    );
  }

  if (isAuthenticated && !hasLegalAge) {
    return (
      <Alert
        type="warning"
        message={
          <span>
            Du måste vara 18 år för att köpa lotter.
            <br /> Om du har frågor är du välkommen att kontakta givarservice på{' '}
            <ContactLink href="tel:+46101991010">010-199 10 10.</ContactLink>
          </span>
        }
      />
    );
  }

  return <>{children}</>;
}
